export default async function querySubscription(lineUserId) {
  const url = `/subscriptions/${lineUserId}/query`
  const resp = await fetch(url, {
    headers: {
      Authorization: 'Token token=""',
    },
  })
  if (resp.status == 200) {
    const data = resp.json()
    return data
  } else {
    return false
  }
}

